import { MembershipTypes } from '../../../../../../general/js/utils';
import { addressesFormStateConstants } from './user-account/address-form-state';
import { orderHistoryFormStateConstants } from './user-account/order-history-form-state';

export default {
    oneClubRegisterFormState: {
        membership: MembershipTypes.OneClub,
        isSaving: false,
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false
    },
    defaultRegisterFormState: {
        membership: MembershipTypes.OneClub,
        isSaving: false,
        errors: {},
        formHasErrors: false
    },
    ballotRegisterFormState: {
        membership: MembershipTypes.OneClub,
        isSaving: false,
        errors: {},
        formHasErrors: false,
        emailCheckInProgress: false
    },
    ticketingRegisterFormState: {
        membership: MembershipTypes.OneClub,
        isSaving: false,
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false,
        privacyPolicy: false,
        oneClubTermsAndServices: false
    },
    userDetailsFormState: {
        isSaving: false,
        formData: {},
        isConfirmationPopUpOpen: false,
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false,
        isUserUpdatingEmail: false
    },
    changePasswordFormState: {
        errors: {},
        formHasErrors: false
    },
    userAddressesFormState: {
        isSaving: false,
        formState: addressesFormStateConstants.AddressDisplayForm,
        accountData: {},
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false
    },
    emailNotificationSettingsFormState: {
        isSaving: false,
        formData: {},
        accountData: {},
        errors: {},
        formHasErrors: false
    },
    theOneClubFormState: {
        isSaving: false,
        formData: {},
        leaveOneClubCheck: false,
        accountData: {},
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false
    },
    orderHistoryFormState: {
        orderHistoryData: {},
        orderHistoryActivePageNumber: 1,
        displayCancelledFiles: false,
        formState: orderHistoryFormStateConstants.OrderHistoryDisplayForm,
        fileNumberForDisplay: 0
    },
    userTicketsFormState: {
        hideOldTickets: true,
        isTicketPrintModalOpen: false,
        printOptions: {},
        modalFormData: {}
    },
    addUserAddressesFormState: {
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false
    },
    updateUserAddressesFormState: {
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false
    },
    upgradeAccountFormState: {
        activeMemberships: [],
        isSaving: false,
        userAccountData: {},
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false,
        isSubmitAction: false
    },
    upgradeBallotFormState: {
        activeMemberships: [MembershipTypes.OneClub],
        isSaving: false,
        userAccountData: {},
        availableCounties: {},
        availableStates: {},
        errors: {},
        formHasErrors: false,
        isSubmitAction: false
    },
    ssoItemListFormState: {
        itemList: [],
        loading: false
    },
    signInFormState: {
        errors: {},
        isProcessing: false,
        formHasErrors: false
    },
    newPasswordRequiredFormState: {
        errors: {},
        isProcessing: false,
        formHasErrors: false
    },
    forgotPasswordFormState: {
        errors: {},
        isProcessing: false,
        formHasErrors: false
    },
    resetPasswordFormState: {
        errors: {},
        verificationCode: '',
        isProcessing: false
    },
    verifyEmailFormState: {
        errors: {},
        verificationCode: '',
        isProcessing: false
    },
    referAFriendFormState: {
        isSaving: false,
        formData: {},
        errors: {},
        formHasErrors: false
    },
};
